export const punchInsertionType = {
    PUNCH: 'P',
    MANUAL: 'M'
};